import React, { createContext, useContext, useState, ReactNode } from 'react';

export interface UserData {
  record_id?: string;
  nome?: string;
  dtnasc?: string;
  companyId?: string; // ✅ ADICIONADO
}

export interface UserDataContextType {
  userData: UserData;
  setUserData: (data: UserData) => void;
  updateUserData: (data: Partial<UserData>) => void;
}

const UserDataContext = createContext<UserDataContextType | undefined>(undefined);

export const UserDataProvider = ({ children }: { children: ReactNode }) => {
  const [userData, setUserData] = useState<UserData>({});

  const updateUserData = (data: Partial<UserData>) => {
    setUserData(prev => ({ ...prev, ...data }));
  };

  return (
    <UserDataContext.Provider value={{ userData, setUserData, updateUserData }}>
      {children}
    </UserDataContext.Provider>
  );
};

export const useUserData = () => {
  const context = useContext(UserDataContext);
  if (!context) {
    throw new Error('useUserData must be used within UserDataProvider');
  }
  return context;
};